import React, { Component, Fragment } from "react";

class Slider extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value || 0,
			step: props.step || 1
		};

		this.handleChange = this.handleChange.bind(this);
		this.valorMaisProximo = this.valorMaisProximo.bind(this);
	}

	componentDidMount() {
		this.setState({ value: this.props.value });
	}
	componentWillReceiveProps(nextProps) {
		this.setState({ value: nextProps.value });
	}

	handleChange(e) {
		e.preventDefault();
		const { validRange } = this.props;

		let value = e.target.value;
		let invalid = validRange && !validRange.find(option => option.value == value);

		this.setState({
			value: value,
			invalid
		});

		if (!invalid) {
			this.props.onChange(value);
		}
	}

	numberWithCommas = (n = 0) => {
		return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
	};

	validRangeText = valid => {
		return this.state.value != this.props.defaultValue ? (
			valid ? (
				<strong>Dentro da faixa</strong>
			) : this.state.invalid ? (
				<strong>Média inválida!</strong>
			) : (
				<strong>Fora da faixa</strong>
			)
		) : (
			<strong>Melhor média</strong>
		);
	};

	valorMaisProximo = e => {
		const { validRange } = this.props;

		if (!validRange) return;

		// Set vars
		let valor = Number(e.target.value),
			lo = 0,
			hi = validRange.length;

		// Find the number
		while (hi - lo > 1) {
			let mid = Math.round((lo + hi) / 2);
			if (validRange[mid].value <= valor) {
				lo = mid;
			} else {
				hi = mid;
			}
		}

		// Set min range
		if (validRange[lo].value >= valor) hi = lo;

		let invalid = validRange && !validRange.find(option => option.value == validRange[hi].value);

		this.setState({
			value: validRange[hi].value,
			invalid
		});

		if (!invalid) {
			this.props.onChange(validRange[hi].value);
		}
	};

	render() {
		const { invalid } = this.state;
		const { className, max, min, step, defaultValue, rangeMin, rangeMax, validRange } = this.props;
		let dataAction = this.props.hasOwnProperty("data-action")
			? this.props["data-action"]
			: "range-offers";
		let valid = this.state.value >= rangeMin && this.state.value <= rangeMax && !invalid;

		const style = ["slider-component d-flex", className].join(" ");

		return (
			<div className={style} data-action={dataAction}>
				<div className="slider-component__info d-flex">
					<div
						className="slider-component__info--side slider-component__info--side--left"
						style={{ flex: rangeMin }}
					>
						<strong>Média: </strong>
					</div>
					<div
						className="slider-component__info--side slider-component__info--side--center"
						style={{ flex: rangeMax - rangeMin }}
					>
						<div className="range-info range-info--left">
							{this.numberWithCommas(rangeMin)} milhas
						</div>
						<div className="range-info range-info--top">Faixa dinâmica</div>
						<div className="range-info range-info--right">
							{this.numberWithCommas(rangeMax)} milhas
						</div>
					</div>
					<div
						className="slider-component__info--side slider-component__info--side--right"
						style={{ flex: max - rangeMax }}
					>
						<strong>+ de {this.numberWithCommas(max)} milhas</strong>
					</div>
				</div>
				<div className="slider-component__slider d-flex">
					<input
						className="slider-component__range slider-component__default-range"
						type="range"
						disabled={true}
						value={defaultValue}
						min={min}
						max={max}
					/>
					<input
						className={`slider-component__range ${valid ? "green-value" : "red-value"}`}
						type="range"
						onChange={this.handleChange}
						value={this.state.value}
						min={min}
						max={max}
						step={step}
						onMouseUp={e => this.valorMaisProximo(e)}
						onTouchEnd={e => this.valorMaisProximo(e)}
					/>
				</div>
				<div className="slider-component__subtitle d-flex">
					<div className="slider-component__subtitle--default d-flex">
						<span style={{ flex: defaultValue || 1 }}>
							<div className="slider-component__subtitle--value--align">
								{this.state.value >= rangeMin && this.state.value <= rangeMax ? (
									<Fragment />
								) : (
									<Fragment>
										<strong>Mais vendida</strong>
										{this.numberWithCommas(defaultValue)} milhas
									</Fragment>
								)}
							</div>
						</span>
						<span style={{ flex: max - defaultValue || 1 }} />
					</div>
					<div className="slider-component__subtitle--value d-flex">
						<span style={{ flex: this.state.value || 1 }}>
							<div
								className={`slider-component__subtitle--value--align ${
									valid ? "green-value" : "red-value"
								}`}
							>
								{this.validRangeText(valid)}
								{this.numberWithCommas(this.state.value)} milhas
							</div>
						</span>
						<span style={{ flex: (max < this.state.value ? 500 : max - this.state.value) || 1 }} />
					</div>
				</div>
			</div>
		);
	}
}

export default Slider;
